import React, { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import "./GiftEnvelope.css";

// Function to create confetti particles
const createConfetti = (container) => {
    const confettiPieces = 50;
    const colors = ["#FF6B6B", "#4ECDC4", "#FFE66D", "#95E1D3", "#F38181", "#AA96DA", "#FCBAD3"];

    for (let i = 0; i < confettiPieces; i++) {
        const confetti = document.createElement("div");
        confetti.className = "confetti-piece";
        confetti.style.left = Math.random() * 100 + "%";
        confetti.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
        confetti.style.animation = `confetti-fall ${2 + Math.random() * 2}s ease-in forwards`;
        confetti.style.animationDelay = Math.random() * 0.3 + "s";
        container.appendChild(confetti);
    }
};

// Function to create balloons
const createBalloons = (container) => {
    const balloonCount = 8;
    const colors = ["#FF6B6B", "#4ECDC4", "#FFE66D", "#95E1D3", "#F38181", "#AA96DA", "#FCBAD3", "#FFA07A"];

    for (let i = 0; i < balloonCount; i++) {
        const balloon = document.createElement("div");
        balloon.className = "celebration-balloon";
        balloon.style.left = Math.random() * 80 + 10 + "%";
        balloon.style.backgroundColor = colors[i % colors.length];
        balloon.style.animation = `balloon-rise ${3 + Math.random() * 2}s ease-in forwards`;
        balloon.style.animationDelay = Math.random() * 0.5 + "s";
        container.appendChild(balloon);
    }
};

function Envelope({ imageUrl, setisZommImage, setCustomized, issendECard,
    envelopecolor = "",
    ecardbgcolor = "",
    rippencolor = "",
    setenvelopecolor,
    setecardbgcolor,
    setrippencolor
}) {
    const envelopeRef = useRef(null);
    const paperRef = useRef(null);
    const envelopeBodyRef = useRef(null);

    const flip = useRef();
    const open = useRef();
    const zoom = useRef();
    const ribbon = useRef();

    const [showEditor, setShowEditor] = useState(false);

    useEffect(() => {
        const el = envelopeRef.current;

        flip.current = gsap.timeline({ paused: true });
        open.current = gsap.timeline({ paused: true });
        zoom.current = gsap.timeline({ paused: true });
        ribbon.current = gsap.timeline({ paused: true });

        gsap.set(el, { rotateY: 180 });

        flip.current
            .to(el, { duration: 0.6, rotateY: 0, ease: "power2.inOut" })
            .to(".cover", { opacity: 1, duration: 0 }, 0)
            .to(".bow-wrapper", { opacity: 0, scale: 0.5, duration: 0.3 }, 0);

        open.current
            .to(".top-cover", {
                duration: 0.5,
                rotateX: 180,
                transformOrigin: "top"
            })
            .to(".top", { zIndex: 1 }, 0.05);

        zoom.current
            .to(paperRef.current, { zIndex: 1 }, 0.3)
            .to(paperRef.current, {
                duration: 0.5,
                y: -120,
                opacity: 1,
                visibility: "visible",
                zIndex: 2
            }, 0.5)
            .to(paperRef.current, {
                duration: 0.5,
                scale: 2,
                y: 0,
                zIndex: 3
            }, 1);

        ribbon.current.to(".ribbon", {
            duration: 0.4,
            scaleX: 0,
            transformOrigin: "center"
        });

        //setTimeout(handleOpen, 500);
    }, []);

    const handleOpen = () => {
        if (
            flip.current.isActive() ||
            open.current.isActive() ||
            zoom.current.isActive()
        ) return;

        paperRef.current.classList.add("show");

        flip.current.play(0);
        setTimeout(() => ribbon.current.play(0), 400);
        open.current.play(0);
        zoom.current.play(0);

        // Trigger celebratory effects
        setTimeout(() => {
            const celebrationContainer = document.createElement("div");
            celebrationContainer.className = "celebration-container";
            envelopeBodyRef.current?.appendChild(celebrationContainer);

            // Create confetti and balloons
            createConfetti(celebrationContainer);
            createBalloons(celebrationContainer);

            // Remove the celebration container after animations complete
            setTimeout(() => {
                celebrationContainer.remove();
            }, 5000);
        }, 400);
    };
    const handleResetColors = () => {
        setenvelopecolor("#6c6ca8");
        setecardbgcolor("#d8d8fb");
        setrippencolor("#ff3b3b");
    };

    const handleClose = (e) => {
        e.stopPropagation();

        zoom.current.reverse();
        ribbon.current.reverse();

        setTimeout(() => open.current.reverse(), 800);
        setTimeout(() => {
            if (paperRef.current) {
                paperRef.current.classList.remove("show");
            }
        }, 1200);
        setTimeout(() => flip.current.reverse(), 1400);
    };

    return (
        <>
            <p className="textnote">
                Note : Click on the envelope to view a preview of your E-Card.
            </p>
            <div className="envelopebody" style={{ backgroundColor: ecardbgcolor }} ref={envelopeBodyRef}>

                {/* ✅ Edit Button */}
                {(issendECard && !showEditor) && <div className="edit-btn" onClick={() => setShowEditor(!showEditor)}>
                    🎨
                </div>}

                {/* ✅ Color Picker Panel */}
                {showEditor && (
                    <div className="color-panel" onClick={(e) => e.stopPropagation()}>
                        <div className="close" onClick={() => { setShowEditor(false) }}>✕</div>
                        <label>Background</label>
                        <input type="color" value={ecardbgcolor} onChange={(e) => setecardbgcolor(e.target.value)} />

                        <label>Envelope</label>
                        <input type="color" value={envelopecolor} onChange={(e) => setenvelopecolor(e.target.value)} />

                        <label>Ribbon</label>
                        <input type="color" value={rippencolor} onChange={(e) => setrippencolor(e.target.value)} />

                        {/* ✅ Reset Button */}
                        <button className="btn button-back  btn-danger" onClick={handleResetColors}>
                            Reset
                        </button>
                    </div>
                )}

                <div
                    className="envelope"
                    ref={envelopeRef}
                    onClick={handleOpen}
                    style={{ backgroundColor: envelopecolor }}
                >
                    <div className="back-face" style={{ backgroundColor: envelopecolor }}></div>

                    <div className="cover">
                        <div className="bottom" style={{ backgroundColor: envelopecolor }}></div>

                        <div className="side">
                            <div className="left" style={{ backgroundColor: envelopecolor }}></div>
                            <div className="right" style={{ backgroundColor: envelopecolor }}></div>
                        </div>

                        <div className="top">
                            <div className="top-cover" style={{ backgroundColor: envelopecolor }}></div>
                        </div>
                    </div>

                    <div className="ribbon" style={{ backgroundColor: rippencolor }}></div>

                    <div className="bow-wrapper">
                        <div className="bow">
                            <div className="loop left" style={{ backgroundColor: rippencolor }}></div>
                            <div className="loop right" style={{ backgroundColor: rippencolor }}></div>
                            <div className="knot" style={{ backgroundColor: rippencolor }}></div>
                            <div className="tail left" style={{ backgroundColor: rippencolor }}></div>
                            <div className="tail right" style={{ backgroundColor: rippencolor }}></div>
                        </div>
                    </div>

                    <div className="paper" ref={paperRef}>
                        <img
                            onClick={() => setisZommImage(true)}
                            src={imageUrl}
                            className="portrait"
                            style={{ background: ecardbgcolor }}
                        />
                        <div className="close" onClick={handleClose}>✕</div>
                    </div>

                    <div className="shadow"></div>
                </div>
            </div>
        </>
    );
}

export default React.memo(Envelope);